export const getRemitos = 'remitos'
export const createRemito = 'remitos'
export const createRemitoItems = 'detalle-remitos'
export const getRemito = 'remitos'
export const sendPhoto = {
    proveedor: 'remitos-files', clienteInterno: 'remitos-files-cliente',
}
